import { saveAs } from 'file-saver'
import b64toBlob from 'b64-to-blob'
import { defer, finalize, Observable, tap } from 'rxjs'
import { IExportFileResponse } from '../interfaces/export-file.interface'

const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** Saves a base64 workbook returned by an `ExcelResponse` endpoint under its server-provided filename. */
function saveExportFile(res: IExportFileResponse) {
  saveAs(b64toBlob(res.data, XLSX_MIME_TYPE), res.filename)
}

/** Runs an export request and saves the workbook it returns; `setLoading` is true for the life of the request. */
export function exportToFile(
  request$: Observable<IExportFileResponse>,
  setLoading: (isLoading: boolean) => void
): Observable<IExportFileResponse> {
  return defer(() => {
    setLoading(true)
    return request$
  }).pipe(
    tap(saveExportFile),
    finalize(() => setLoading(false))
  )
}
